import React, { Component } from 'react';

//Core Libs
import prd from "../../Core/Products"; 

class Categories extends Component {
	
	constructor( props ){
		super( props );

		this.state = {
			categories: [],
			list: '',
		}

		this.categories = [];

	}

	checkChanged = (e) => {

		if( e.target.getAttribute('class').indexOf('checked') > -1 ) {
			e.target.setAttribute('class', 'checkbox')
		} else {
			e.target.setAttribute('class', 'checkbox checked')
		}		
		
		let i = this.categories.indexOf(  e.target.getAttribute('data-value') )

		if( i === -1 ) {
			this.categories.push( e.target.getAttribute('data-value') );
		} else {
			this.categories.splice(i, 1);
		}
	
		this.props.setFilters({
			catID: this.categories
		});

	}


	getCategories = () => {
		prd.getCatgories('ACCESSORY', (response) => {
			this.setState({
				categories: response.data
			}, () => this.prepareCategories() );
		});
	}

	prepareCategories = () => {
		
		let list = [];

		for( let i = 0; i < this.state.categories.length; i++) {
			list.push( 
				<li key={i}>
					<span data-value={this.state.categories[i].catID} className="checkbox" onClick={this.checkChanged} >
						{ this.state.categories[i].catName }
					</span>
				</li>
			)
		}

		this.setState({
			list
		});

	}

	componentDidMount() {
		this.getCategories();
	}

	render() {
		return (
			<div>

			{
				this.state.list.length > 0 
					? (
						<div>
							<div className="filter-head">Kategorier: </div>
							<ul className="checkbox-wrapper">								
								{ this.state.list }
							</ul>							
						</div>
					)
					: null 
			}

			</div>
		)
	}
}

export default Categories;


// WEBPACK FOOTER //
// ./src/Reducer/Filters/Categories.js